import { Link } from 'react-router';
import { Button } from '../buttons/Button';
import { DimensionFeedback } from './DimensionFeedback';
import { PlanRadarChart } from './PlanRadarChart';
import { DIMENSIONS, PlanResponse } from '../../lib/plan/types';

interface PlanResultsProps {
    plan: PlanResponse;
}

export function PlanResults({ plan }: PlanResultsProps) {
    const { dimension_scores, primary_dimension } = plan;
    const orderedDimensions = [
        primary_dimension,
        ...DIMENSIONS.filter((dim) => dim !== primary_dimension),
    ];

    return (
        <div className="mx-auto max-w-3xl">
            <div className="mb-6 text-center">
                <h4>Profil vaší třídy</h4>
                <p className="text-sm text-ink-700">
                    Silné stránky i místa, kde třída potřebuje podporu
                </p>
            </div>

            <div className="flex flex-wrap items-center gap-6 rounded-2xl bg-white p-6 shadow-sm">
                <div className="mx-auto">
                    <PlanRadarChart
                        scores={dimension_scores}
                        primary={primary_dimension}
                    />
                </div>
                <div className="min-w-[240px] flex-1 space-y-3">
                    {orderedDimensions.map((dimension) => (
                        <DimensionFeedback
                            key={dimension}
                            dimension={dimension}
                            score={dimension_scores[dimension]}
                            isPrimary={dimension === primary_dimension}
                        />
                    ))}
                </div>
            </div>

            <div className="mt-6 rounded-2xl bg-white p-6 text-center shadow-sm">
                <p className="mb-4 text-ink-800">
                    Profil není cíl — je to východisko vaší cesty.
                </p>
                <Link to="/plan-na-miru" className="inline-block">
                    <Button color="product">Zobrazit plán</Button>
                </Link>
            </div>
        </div>
    );
}
